import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'i2g-job-detail-header',
  templateUrl: 'job-detail-header.component.html',
  styleUrls: ['job-detail-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobDetailHeaderComponent implements OnInit {
  @Input() label: string;
  @Input() number: string;
  @Input() subLabel: string;

  constructor() {}

  ngOnInit() {}
}
